export default __webpack_public_path__ + "./images/ro.65745999.png";